module.exports = __webpack_public_path__ + "static/media/loaderlogo.3b0986c0.svg";